// src/components/InternalQuotaButton/InternalQuotaButton.jsx
import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import styles from './InternalQuotaButton.module.scss';
import Modal from '../Modal/Modal';
import Cotizador from '../Cotizador/Cotizador';

const InternalQuotaButton = () => {
  const [cotizadorOpen, setCotizadorOpen] = useState(false);

  // Bloquear/desbloquear scroll de fondo al abrir/cerrar el cotizador
  useEffect(() => {
    document.body.style.overflow = cotizadorOpen ? 'hidden' : 'auto';
    return () => { document.body.style.overflow = 'auto'; };
  }, [cotizadorOpen]);

  const openCotizador = () => {
    if (typeof window !== 'undefined') {
      TagManager.dataLayer({
        dataLayer: {
          event: 'ux_event',
          event_name: 'linea_solicitar_cotizacion',
          event_category: 'engagement',
          event_label: 'Solicitud de Cotización - Interno',
          value: 1,
        },
      });
    }
    setCotizadorOpen(true);
  };

  const closeCotizador = () => setCotizadorOpen(false);

  return (
    <>
      {/* Botón principal */}
      <div className={styles.buttonContainer} onClick={openCotizador}>
        <div className={styles.buttonContent}>
          <span>COTIZAR</span>
        </div>
      </div>

      {/* Modal Cotizador */}
      <Modal isOpen={cotizadorOpen} onClose={closeCotizador}>
        <Cotizador onClose={closeCotizador} />
      </Modal>
    </>
  );
};

export default InternalQuotaButton;
